/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { Typography, Image, Carousel } from 'antd';
import { HomeOutlined, PlayCircleOutlined, HeartOutlined } from '@ant-design/icons';
import PhotoAlbum from 'react-photo-album';
import Lightbox from 'yet-another-react-lightbox';
// eslint-disable-next-line import/no-unresolved
import 'yet-another-react-lightbox/styles.css';

import { useSelector } from 'react-redux';
import LazyLoad from 'react-lazy-load';
import { getBranchById } from '../../utils/branches';

import durango1 from '../../assets/info/durango/Establecimiento_1.webp';
import durango2 from '../../assets/info/durango/Establecimiento_2.webp';
import durango3 from '../../assets/info/durango/Establecimiento_3.webp';
import durango4 from '../../assets/info/durango/Establecimiento_4.webp';
import durango5 from '../../assets/info/durango/Establecimiento_5.webp';
import durango6 from '../../assets/info/durango/Establecimiento_6.webp';
import durango7 from '../../assets/info/durango/Establecimiento_7.webp';

import tmbDurango1 from '../../assets/info/durango/Establecimiento_1_tmb.webp';
import tmbDurango2 from '../../assets/info/durango/Establecimiento_2_tmb.webp';
import tmbDurango3 from '../../assets/info/durango/Establecimiento_3_tmb.webp';
import tmbDurango4 from '../../assets/info/durango/Establecimiento_4_tmb.webp';
import tmbDurango5 from '../../assets/info/durango/Establecimiento_5_tmb.webp';
import tmbDurango6 from '../../assets/info/durango/Establecimiento_6_tmb.webp';
import tmbDurango7 from '../../assets/info/durango/Establecimiento_7_tmb.webp';

import './UsersInfo.css';
import restaurantSelector from '../../redux/selectors/restaurantSelector';
import widthHeightSelector from '../../redux/selectors/widthHeightSelector';

function UsersInfo() {
  const { number } = useSelector(restaurantSelector);
  const branch = getBranchById(number);
  const { width } = useSelector(widthHeightSelector);
  const [index, setIndex] = useState(-1);

  const isMobile = width < 768;

  const branchPhotoSets = {
    1: {
      photos: [
        {
          src: durango1,
          width: 3666,
          height: 2444,
          alt: 'Foto del establecimiento',
        },
        {
          src: durango5,
          width: 2626,
          height: 1751,
          alt: 'Foto del establecimiento',
        },
        {
          src: durango3,
          width: 3502,
          height: 2334,
          alt: 'Foto del establecimiento',
        },
        {
          src: durango4,
          width: 4209,
          height: 1460,
          alt: 'Foto del establecimiento',
        },
        {
          src: durango2,
          width: 3666,
          height: 2444,
          alt: 'Foto del establecimiento',
        },
        {
          src: durango6,
          width: 2719,
          height: 1812,
          alt: 'Foto del establecimiento',
        },
        {
          src: durango7,
          width: 3471,
          height: 1303,
          alt: 'Foto del establecimiento',
        },
      ],
      thumbnails: [
        {
          src: tmbDurango1,
          width: 3666,
          height: 2444,
          alt: 'Foto del establecimiento',
        },
        {
          src: tmbDurango5,
          width: 2626,
          height: 1751,
          alt: 'Foto del establecimiento',
        },
        {
          src: tmbDurango3,
          width: 3502,
          height: 2334,
          alt: 'Foto del establecimiento',
        },
        {
          src: tmbDurango4,
          width: 4209,
          height: 1460,
          alt: 'Foto del establecimiento',
        },
        {
          src: tmbDurango2,
          width: 3666,
          height: 2444,
          alt: 'Foto del establecimiento',
        },
        {
          src: tmbDurango6,
          width: 2719,
          height: 1812,
          alt: 'Foto del establecimiento',
        },
        {
          src: tmbDurango7,
          width: 3471,
          height: 1303,
          alt: 'Foto del establecimiento',
        },
      ],
    },
  };
  const currentPhotos = branchPhotoSets[branch.id] ?? branchPhotoSets[1];
  const { photos } = currentPhotos;
  const { thumbnails } = currentPhotos;
  return (
    <div
      id="facilities"
      className="facilities-section"
    >
      <div className="facilities-container">
        <div className="facilities-header">
          <Typography.Title level={2} className="facilities-title">
            Nuestras Instalaciones
          </Typography.Title>
          <div className="features-grid">
            <div className="feature-item">
              <HomeOutlined className="feature-icon" />
              <Typography.Text className="feature-text">Ambiente familiar y acogedor</Typography.Text>
            </div>
            <div className="feature-item">
              <PlayCircleOutlined className="feature-icon" />
              <Typography.Text className="feature-text">Bar deportivo con pantallas</Typography.Text>
            </div>
            <div className="feature-item">
              <HeartOutlined className="feature-icon" />
              <Typography.Text className="feature-text">Área infantil segura</Typography.Text>
            </div>
          </div>
        </div>

        <div className="gallery-container">
          {isMobile ? (
            <Carousel autoplay dots className="mobile-carousel">
              {thumbnails.slice(0, 4).map((photo, i) => (
                <div key={i} className="carousel-slide">
                  <Image
                    src={photo.src}
                    alt={photo.alt}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    className="carousel-image"
                    preview={{ src: photos[i]?.src }}
                  />
                </div>
              ))}
            </Carousel>
          ) : (
            <LazyLoad>
              <PhotoAlbum
                layout="columns"
                photos={thumbnails}
                onClick={({ index: i }) => setIndex(i)}
                spacing={12}
                columns={(containerWidth) => {
                  if (containerWidth < 800) return 2;
                  return 3;
                }}
              />
            </LazyLoad>
          )}
          <Lightbox
            slides={photos}
            open={index >= 0}
            index={index}
            close={() => setIndex(-1)}
          />
        </div>
      </div>
    </div>
  );
}

export default UsersInfo;
